import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC7RuXcrGbyfstiimYN9ynj3YQAdxwug18",
  authDomain: "liquidhearts.firebaseapp.com",
  projectId: "liquidhearts",
  storageBucket: "liquidhearts.firebasestorage.app",
  messagingSenderId: "339802941008",
  appId: "1:339802941008:web:d295b5eda3248d46235355",
  measurementId: "G-JQYPM04LQ8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default { app, analytics };
